// extracted by mini-css-extract-plugin
export var section = "cases-module--section--26ynq";
export var header = "cases-module--header--2X3dm";
export var jsAnimInit = "cases-module--jsAnimInit--BXiSp";
export var title = "cases-module--title--2Tsom";